{
  "name": "supp-administrativo-frontend",
  "version": "1.39.0",
  "license": "https://www.agu.gov.br",
  "scripts": {
    "ng": "ng",
    "start": "ng serve  --host 0.0.0.0 --port 4200",
    "build": "node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build --dev",
    "build-stats": "node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build --dev --stats-json",
    "build-prod": "node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build --configuration production",
    "build-prod-stats": "node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build --configuration production --stats-json",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "bundle-report": "webpack-bundle-analyzer dist/stats.json"
  },
  "dependencies": {
    "@angular-architects/ngrx-toolkit": "21.0.1",
    "@angular/animations": "^21.2.4",
    "@angular/build": "^21.2.2",
    "@angular/cdk": "^21.2.2",
    "@angular/common": "^21.2.4",
    "@angular/compiler": "^21.2.4",
    "@angular/core": "^21.2.4",
    "@angular/forms": "^21.2.4",
    "@angular/material": "^21.2.2",
    "@angular/material-luxon-adapter": "^21.2.2",
    "@angular/platform-browser": "^21.2.4",
    "@angular/platform-browser-dynamic": "^21.2.4",
    "@angular/router": "^21.2.4",
    "@ckeditor/ckeditor5-angular": "11.2.0",
    "@drecom/idb-cache": "1.1.0",
    "@kariudo/ng2-pdfjs-viewer": "19.1.0",
    "@materia-ui/ngx-monaco-editor": "6.0.0",
    "@ngrx-traits/signals": "^21.0.1",
    "@ngrx/effects": "21.0.1",
    "@ngrx/operators": "21.0.1",
    "@ngrx/router-store": "21.0.1",
    "@ngrx/signals": "21.0.1",
    "@ngrx/store": "21.0.1",
    "@ngrx/store-devtools": "21.0.1",
    "@ngx-translate/core": "17.0.0",
    "@playwright/test": "1.57.0",
    "@primeuix/styles": "2.0.3",
    "@primeuix/themes": "2.0.3",
    "@swimlane/ngx-charts": "23.0.1",
    "@thebespokepixel/es-tinycolor": "3.1.0",
    "@types/ckeditor": "4.9.10",
    "@types/prismjs": "1.26.5",
    "ag-grid-angular": "34.1.1",
    "ag-grid-community": "34.1.1",
    "angular-calendar": "0.31.1",
    "angular-imask": "7.6.1",
    "angular-in-memory-web-api": "0.21.0",
    "angular-resizable-element": "7.0.2",
    "angular-shepherd": "22.0.0",
    "apexcharts": "3.42.0",
    "base-64": "^1.0.0",
    "brazil-currencies": "0.1.0",
    "buffer": "^6.0.3",
    "chart.js": "4.4.0",
    "ckeditor5": "48.5.3",
    "class-transformer": "0.5.1",
    "classlist.js": "1.1.20150312",
    "core-js": "3.32.2",
    "coverage": "^0.0.0",
    "cronstrue": "2.32.0",
    "crypto-js": "4.2.0",
    "css-element-queries": "1.2.3",
    "d3": "7.8.5",
    "date-fns": "2.30.0",
    "es6-shim": "^0.35.8",
    "event-source-polyfill": "1.0.31",
    "hammerjs": "2.0.8",
    "highlight.js": "11.11.1",
    "jsoneditor": "9.10.2",
    "localstorage-slim": "^2.7.1",
    "lodash-es": "^4.18.1",
    "luxon": "^3.7.2",
    "material-community-components": "13.0.0",
    "monaco-editor": "0.43.0",
    "ng-apexcharts": "2.0.0",
    "ng2-ckeditor": "1.3.7",
    "ngx-color-picker": "20.1.1",
    "ngx-cookie-service": "21.1.0",
    "ngx-currency": "19.0.0",
    "ngx-drag-drop": "21.0.0",
    "ngx-image-cropper": "7.2.1",
    "ngx-infinite-scroll": "21.0.0",
    "ngx-quill": "28.0.1",
    "ngx-turnstile": "0.2.4",
    "ngx-upper-case-directive": "2.0.0",
    "perfect-scrollbar": "1.5.6",
    "primeicons": "7.0.0",
    "primeng": "21.1.3",
    "prismjs": "1.30.0",
    "qrcode": "^1.5.3",
    "quill": "2.0.2",
    "reflect-metadata": "0.2.2",
    "rxjs": "7.8.2",
    "safe-pipe": "3.0.4",
    "sass": "1.85.1",
    "tailwindcss-primeui": "0.6.1",
    "text-mask-addons": "3.8.0",
    "tinycolor2": "1.6.0",
    "ts-mockito": "^2.6.1",
    "tslib": "2.8.1",
    "web-animations-js": "2.3.2",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.2",
    "@angular-eslint/builder": "^21.3.0",
    "@angular-eslint/eslint-plugin": "^21.3.0",
    "@angular-eslint/eslint-plugin-template": "^21.3.0",
    "@angular-eslint/schematics": "^21.3.0",
    "@angular-eslint/template-parser": "^21.3.0",
    "@angular/cli": "^21.2.2",
    "@angular/compiler-cli": "^21.2.4",
    "@angular/language-service": "^21.2.4",
    "@tailwindcss/typography": "0.5.20",
    "@types/base-64": "^1.0.2",
    "@types/chroma-js": "2.4.5",
    "@types/crypto-js": "^4.2.2",
    "@types/highlight.js": "10.1.0",
    "@types/jasmine": "4.3.5",
    "@types/lodash": "4.17.23",
    "@types/lodash-es": "4.17.12",
    "@types/luxon": "3.7.1",
    "@types/node": "22.19.0",
    "@typescript-eslint/eslint-plugin": "8.39.1",
    "@typescript-eslint/parser": "8.39.1",
    "autoprefixer": "10.4.15",
    "chroma-js": "2.4.2",
    "eslint": "9.33.0",
    "eslint-plugin-import": "2.32.0",
    "eslint-plugin-jsdoc": "50.6.2",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "jasmine-core": "^5.2.0",
    "jasmine-spec-reporter": "7.0.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-coverage-istanbul-reporter": "3.0.3",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.1.0",
    "karma-spec-reporter": "^0.0.36",
    "lodash": "4.18.1",
    "ng-mocks": "^14.13.1",
    "patch-package": "8.0.1",
    "postcss": "^8.5.14",
    "tailwindcss": "3.4.18",
    "typescript": "5.9.3",
    "webpack-bundle-analyzer": "4.9.1"
  }
}
